import * as React from 'react';
import { observer } from 'mobx-react-lite';
import {
    skittleCalloutBasicSecondPartText,
    skittleCalloutBasicFirstPartText,
    skittleCalloutTextWhenNoSuggestionFound,
    skittleCalloutBasicSecondPartTextOneSuggestion,
} from './SkittleCallout.locstring.json';
import loc, { format } from 'owa-localize';

const styles = require('./UpsellSkittle.scss');

export interface UpsellSkittleCalloutBasicTextProps {
    premimumFlagsFound: number;
    premiumCategories: string;
    upsellClicked: () => void;
}

const UpsellSkittleCalloutBasicText = observer(function UpsellSkittleCalloutBasicText(
    props: UpsellSkittleCalloutBasicTextProps
) {
    const { premimumFlagsFound, premiumCategories } = props;
    if (premimumFlagsFound > 0) {
        const secondPartTextSuggestion =
            premimumFlagsFound === 1
                ? skittleCalloutBasicSecondPartTextOneSuggestion
                : skittleCalloutBasicSecondPartText;
        const secondPartText = format(loc(secondPartTextSuggestion), premiumCategories);

        return (
            <div className={styles.skittleCalloutTextContainer}>
                <span>{loc(skittleCalloutBasicFirstPartText)}</span>
                <span className={styles.premimumFlagsFound}> {premimumFlagsFound} </span>
                <span>{secondPartText}</span>
            </div>
        );
    }

    return (
        <div className={styles.skittleCalloutTextContainer}>
            <div>{loc(skittleCalloutTextWhenNoSuggestionFound)}</div>
        </div>
    );
});

export { UpsellSkittleCalloutBasicText };
